<template>
  <div>
    <v-card class="fullHeight">
      <v-layout row wrap>
        <v-flex xs12 md6 class="pl-4 pr-4 mt-2 mb-2">
          <v-select
            :items="type"
            :label="$translate('INCIDENT_TYPE')"
            v-model="form.incidentType"
            item-text="label"
            item-value="value"
          ></v-select>
          <v-text-field
            :disabled="this.boxConfig.type === 'edit'"
            :label="$translate('INCIDENT_LOCATION')"
            class="select"
            v-model="form.location"
            :placeholder="$translate('INCIDENT_GPS')"
          ></v-text-field>
          <v-textarea
            rows="3"
            auto-grow
            class="select maxScroll"
            :label="$translate('INCIDENT_DESCRIPTION')"
            v-model="form.description"
          />

          <v-tooltip bottom>
            <v-btn
              small
              round
              slot="activator"
              v-if="this.boxConfig.type === 'edit'"
              @click="closeDialog = true"

            >
              <v-icon>delete</v-icon>
            </v-btn>
            <span>{{$translate('INCIDENT_CLOSE')}}</span>
          </v-tooltip>

          <v-layout row>
            <v-tooltip bottom>
              <v-btn
                small
                round
                slot="activator"
                color="secondary"
                @click="cancel"
              >{{$translate('BACK')}}</v-btn>
              <span>{{$translate('BACK')}}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn small round slot="activator" color="primary" @click="save">
                <v-icon>save</v-icon>
              </v-btn>
              <span>{{$translate('SAVE_INCIDENT')}}</span>
            </v-tooltip>
          </v-layout>
        </v-flex>

        <v-flex xs12 md6 class="pl-4 pr-4 mt-2 mb-2">
          <div>
            <v-text-field
              class="select"
              disabled
              :label="$translate('INCIDENT_USER')"
              v-model="form.username"
            ></v-text-field>
          </div>
          <input
            id="file-upload"
            type="file"
            name="files[]"
            ref="uploadFile"
            @change="loadFileFromFileSystem"
            accept="image/*"
            style="display:none;"
          >
          <v-layout row>
            <!-- <label for="file-upload" slot="append"> -->
            <!-- <h4 slot="append" class="addBtn pt-2 px-2" style="width:40%">Upload Photo</h4> -->
            <v-tooltip bottom>
              <v-btn small round slot="activator" target="file-upload" @click="pickFile">
                <v-icon>add_a_photo</v-icon>
              </v-btn>
              <span>{{$translate('UPLOAD_IMAGE')}}</span>
            </v-tooltip>
            <!-- </label> -->

            <v-tooltip bottom>
              <v-btn small round slot="activator" color="primary" @click="savePhoto">{{$translate('SAVE_IMAGE')}}</v-btn>

              <span>{{$translate('SAVE_IMAGE')}}</span>
            </v-tooltip>
          </v-layout>
          <IncidentStoryBoard
            id="story"
            class="m-right mb-4"
            :loading="loadingData"
            :elements="this.form.photos"
          />
        </v-flex>
      </v-layout>
    </v-card>
    <v-snackbar
      color="primary"
      class="mt-5"
      :auto-height="true"
      :timeout="timeout"
      :bottom="true"
      :middle="true"
      v-model="snackbar"
    >
      {{ text }}
      <v-btn flat color="pink" @click.native="snackbar = false">{{$translate('CLOSE')}}</v-btn>
    </v-snackbar>

    <v-dialog v-model="closeDialog" max-width="20%" hide-overlay>
      <v-card>
        <v-card-actions class="py-4 px-4">
          <v-flex>
            <h4 class="title">{{this.$translate('INCIDENT_DIALOG_CLOSE')}}</h4>

            <v-layout row class="mt-4">
              <v-flex md5>
                <v-btn class="light" @click="closeDialog = false">{{this.$translate('NO')}}</v-btn>
              </v-flex>
              <v-flex md2/>
              <v-flex md5>
                <v-btn color="primary" @click="deleteIncident">{{this.$translate('YES')}}</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import BaseObject from "../objects/BaseObject.js";
import IncidentAspect from "../aspects/IncidentAspect.js";
import BasePointAspect from "../aspects/BasePointAspect.js";
import IncidentStoryBoard from "./IncidentStoryBoard.vue";
import * as dssRequest from "../api/dssRequest";
import appConfig from "../../config/app_config";
import { mapGetters } from "vuex";
import { store } from "../store";
import BaseComponent from "./base/BaseComponent.vue";

export default {
  extends: BaseComponent,
  name: "IncidentManagerElement",
  props: {
    boxConfig: {}
  },
  components: {
    IncidentStoryBoard
  },
  data() {
    return {
      timeout: 6000,
      text: "The incident was sent successfully!",
      snackbar: false,
      loading: false,
      loadingData: false,
      closeDialog: false,
      editDialog: false,
      form: IncidentAspect._objectDefinition(),
      story: {},
      type: [],
      value: "",
      incident: "",
      options: {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      },
      comment: ""
    };
  },
  created() {
    for (let i = 1; i < 9; i++) {
      let id = "INC_" + i;
      this.type.push({
        label: this.$translate(id),
        value: this.$translate(id)
      });
    }
    window.EventBus.listen("fillIncidentLocation", data => {
      console.log("fillIncidentLocation called");
      if (this.boxConfig.type !== "edit") {
        this.fillIncidentLocation(data);
      }
    });
  },
  beforeDestroy() {
    window.EventBus.removeListener("clickedLocation", this.addSelectedPoint);
  },
  computed: mapGetters({}),
  mounted() {
    window.EventBus.listen("clickedLocation", this.addSelectedPoint);

    console.log("this.boxConfig", this.boxConfig);
    if (this.boxConfig.type === "edit") {
      this.loadingData = true;
      console.log("received data", this.boxConfig);

      // this.form = this.boxConfig.customData;

      this.form = IncidentAspect._parseIncidentObject(
        this.boxConfig.customData
      );
      this.form.location =
        this.boxConfig.customData.position[1] +
        ", " +
        this.boxConfig.customData.position[0];
      this.getIncidentData();
    }

    this.form.decimal = this.boxConfig.customData.position;
    if (this.boxConfig.type !== "edit") {
      this.form.location = this.boxConfig.customData.gps.degrees;
    }
    this.form.username = this.userName;
  },
  methods: {
    pickFile() {
      this.$refs.uploadFile.click();
    },
    showCloseDialog() {
      console.log("showCloseDialog", this.closeDialog);
      this.closeDialog = true;
    },
    addSelectedPoint(clickedLocation) {
      this.form.decimal = clickedLocation.decimal;
      this.form.location = clickedLocation.degrees;
    },
    getSaveButtonText() {
      let text = this.$translate("SAVE");
      if (this.boxConfig.type === "edit") {
        text = this.$translate("INCIDENT_EDIT");
      }
      return text;
    },

    deleteIncident() {
      console.log("deleteIncident", this.form, this.boxConfig.customData);
      this.boxConfig.customData.dataFieldTable.state = "OFF";
      const objId = this.boxConfig.customData.dataFieldTable.locationId;
      let requestObject = IncidentAspect._createRequestObjectNew(
        this.form,
        this.boxConfig.customData
      );
      console.log("deleteIncident requestObject", requestObject, this.form);
      dssRequest.doRequest(
        response => {
          console.log("The call for updateIncident was successful", response)
          window.EventBus.fire(
            "activateSnackBar",
            "Incident was updated successfully!"
          );
          this.cancel();
        },
        error => {
          console.log("The call for updateIncident was not successful", error);
        },
        "updateIncident",
        objId,
        requestObject
      );
    },
    loadFileFromFileSystem(event) {
      console.log("this.photo", this.form.photos);
      this.form.photos = [];
      let userName = this.userName;
      let now = new Date();

      console.log("loadFileFromFileSystem ", event);
      // this.form.photos = [];
      let reader = new FileReader();
      reader.onload = () => {
        this.form.photo = reader.result;
        // console.log("this.form.photo is on loading file from system ", this.form.photo);
        this.form.photos.push({
          userName: userName,
          photo: this.form.photo,
          dateTime: now,
          text: this.comment
        });
        console.log("TRANSLATED PIC", this.form.photos);
      };
      let res = reader.readAsDataURL(event.target.files[0]);
      console.log("loadFileFromFileSystem ", res);
      return true;
    },

    save() {
      let date = new Date();
      if (this.boxConfig.type === "edit") {
        date = this.boxConfig.customData.date;
      }
      this.form.date = date.toLocaleDateString("nl-NL", this.options);

      if (this.boxConfig.type === "edit") {
        let requestObject = IncidentAspect._createRequestObject3(this.form);
        dssRequest.doRequest(
          response => {
            console.log("updateIncident response", response);
            window.EventBus.fire(
              "activateSnackBar",
              "Incident was updated successfully!"
            );
            this.cancel();
          },
          error => {
            console.log("updateIncident error", error);
            window.EventBus.fire(
              "activateSnackBar",
              "Incident update failed!",
              error
            );
          },
          "updateIncident",
          appConfig.dss.userGroupObjectId,
          requestObject
        );
      } else {
        let payload = IncidentAspect._createRequestObject2(this.form);
        dssRequest.doRequest(
          response => {
            console.log("The call for addIncidentAct was successful", response);
            window.EventBus.fire(
              "activateSnackBar",
              "Incident was created successfully!"
            );
            this.cancel();
          },
          error => {
            console.log("The call for addIncidentAct was not successful", error);
            window.EventBus.fire(
              "activateSnackBar",
              "Incident creation failed!",
              error
            );
          },
          "addIncidentAct",
           store.getters.getCurrentAccountId,
          requestObject
         // appConfig.dss.userGroupObjectId
        );
      }
    },

    savePhoto() {
      let payload = IncidentAspect._createAttachmentRequestObject(this.form);
      dssRequest.doRequest(
        response => {
          console.log("The call for insertAttachmentAct was successful", response);
          window.EventBus.fire(
            "activateSnackBar",
            "Incident image was stored successfully!"
          );
          this.cancel();
        },
        error => {
          console.log("The call for insertAttachmentAct was not successful", error);
          window.EventBus.fire("activateSnackBar", error.errorMsg);
        },
        "insertAttachmentAct",
        store.getters.getCurrentAccountId,
        payload
      );
    },
    cancel() {
      window.EventBus.fire("closeAddIncident");
    },
    fillIncidentLocation(data) {
      this.form.decimal = data.decimal;
      this.form.location = data.degrees;
    },
    getIncidentData() {
      let payload = {
        Id: this.boxConfig.customData.id,
        FunctionId: "AspectFunctionLibrary::getAspectWithData"
      };
      // let reqObj = IncidentAspect._getIncidentDataRequest(form.id);



      dssRequest.doRequest(
        response => {
          console.log("The generic call getAspectWithData was successful", response);
          // if (
          //   response.data.IncidentDataSheet[0].IncidentData.Attachment.value !=
          //   "NULL"
          // ) {
          //   this.form.photos.push({
          //     userName: this._userName,
          //     photo:
          //       response.data.IncidentDataSheet[0].IncidentData.Attachment
          //         .value,
          //     dateTime: this.form.date,
          //     text: this.form.description
          //   });
          //   console.log("this.form.photos is ", this.form.photos);
          // }
        },
        error => {
          console.log("The generic call getAspectWithData was not successful", error);
          window.EventBus.fire("activateSnackBar", error.errorMsg);
        },
        "communicateWithDBLibrary",
        this.boxConfig.customData.objectId,
        payload
      );
      this.getIncidentAttachment();
    },
    getIncidentAttachment() {

      let payload = {
        Id: this.boxConfig.customData.id,
        FunctionId: "AspectFunctionLibrary::getAspectAttachment"
      };
      // let reqObj = IncidentAspect._getIncidentDataRequest(form.id);

      dssRequest.doRequest(
        response => {
          console.log("The generic call getAspectAttachment was successful", response);
          let v = BaseObject._createArrayWithObjects(response.data.AspectAttachment);
          if (v.length > 0) {
            this.form.photos.push({
              userName: this.userName,
              photo: v[0].Attachment,
              dateTime: this.form.date,
              text: this.form.description
            });
          }
        },
        error => {
          console.log("The generic call getAspectAttachment was not successful", error);
          window.EventBus.fire("activateSnackBar", error.errorMsg);
        },
        "communicateWithDBLibrary",
        this.boxConfig.customData.objectId,
        payload
      );
    }
  }
};
</script>
<style lang='scss' scoped>
.inc-manager {
  overflow-y: scroll;
}
#name_phone_container {
  display: none;
}

.form {
  height: auto;
  width: 520px;
  margin: 0 0 10px;
  z-index: 15;
}

#location {
  display: none;
}

#saveButton-2 {
  display: none;
}

#editButton {
  display: none;
}

.col-50_l {
  width: 250px;
  height: auto;
  float: left;
}

.col-50_r {
  margin-left: 10px;
  padding: 0 5px;
  width: 250px;
  height: 100% !important;
  min-height: 435px;
  max-height: 575.5px;
  background-color: #d7d8d6;
  float: left;
  overflow-x: hidden;
  overflow-y: auto;
}

.information-text {
  font-size: 0.9em;
  // margin: 15px 0px 2.5px 0px;
}

#small-button_light {
  width: 95% !important;
  text-align: center !important;
  height: 30px;
  padding: 0 0 !important;
  border-radius: 2px !important;
  border: solid 1px #196f93;
  background-color: rgba(0, 0, 0, 0);
  color: #000;
}

#small-button_dark {
  width: 95% !important;
  text-align: center !important;
  height: 30px;
  padding: 0 0 !important;
  border-radius: 2px !important;
  border: solid 1px #196f93;
  background-color: #196f93;
  color: #fff;
}

.button {
  width: 100% !important;
  text-align: center !important;
  height: 30px;
  padding: 0 0 !important;
  border-radius: 2px !important;
  border: none;
  background-color: #84b7c9;
  color: white;
}

.select {
  width: 100%;
  font-size: 12px !important;
}

.el-icon-upload2 {
  cursor: pointer;
  padding: 7px 13.5px;
}

.big-button {
  width: 100%;
  padding: 10px 0;
  background-color: #84b7c9;
  text-align: center;
  color: white;
  font-size: 14px !important;
  cursor: pointer;
  margin: 10px 0 0;
}

.title {
  font-size: 16px !important;
  font-weight: bold;
  text-align: center;
}

.m-top {
  margin-top: 15px;
  width: 100%;
}

.m-right {
  margin-right: 5px;
}

.small-margin {
  margin-top: 2.5px;
}

.dialog-footer {
  width: 100%;
  margin: 0 auto;
}
.fullHeight {
  height: 100% !important;
  overflow-y: auto;
  overflow-x: hidden;
}
.maxScroll {
  overflow-y: auto;
  overflow-x: hidden;
  height: 100px !important;
}
</style>
